import { GQLStory } from '../../@types/server'

export interface ICTEPUBStory extends Omit<GQLStory, 'storyId'> {
  storyId: number | ''
}

export const EPUBStoryPrimaryKey = 'storyId'
